import { useFormikContext } from "formik";
import { FC, useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import ThongTinPhieu from "./ThongTinPhieu";
import ThongTinXuatThuoc from "./ThongTinXuatThuoc";
import WfButton from "../../../../workflows/components/WfButton";
import { TYPE_WH, WAREHOUSE_ID, WF_TRACKER } from "../../../../utils/Constant";
import FormThemVatTu from "./FormThemVatTu";
import { PhieuXuat } from "../../../../phan-he-xuat-kho/models/XuatKhoModel";
import { WMS_STATUS } from "../../../../phan-he-nhap-kho/constants/constansNhapKho";
import { HOAN_TRA_DVKT, trackerCode } from "../../../Constant";
import { AnyAction } from "redux";
import {ConfirmDialog} from "../../../../component/ConfirmDialog";

type Props = {
  isReload?: boolean;
  onHide: () => void;
  type?: any;
  warehouseExportType?: any;
  warehouseId: number;
  listJsonGeneratePhieuXuat?: any;
  isChangeRowData: boolean;
  setIsChangeRowData: React.Dispatch<React.SetStateAction<boolean>>;
};

const FormThemMoi: FC<Props> = (props) => {
  const { warehouseExportType, type, listJsonGeneratePhieuXuat, warehouseId, isChangeRowData, setIsChangeRowData } = props;
  const { handleSubmit, values } = useFormikContext<PhieuXuat>();
  const [statusPhieu, setStatusPhieu] = useState<any>(false);
  const [isView, setIsView] = useState(false);
  const [dataReqWorkflow, setDataReqWorkflow] = useState<any>({});
  const renderButton = () => {
    return (
      <>
        {!isChangeRowData && <WfButton
          tracker={warehouseExportType?.description || trackerCode?.issue_orders_export_summary}
          objectId={values?.phieuXuatKhoAdd?.id}
          // type={warehouseExportType?.code === HOAN_TRA_DVKT.code ? TYPE_WH.IMPORT : TYPE_WH.EXPORT}
          additionalFunc={(data: any) =>
            setStatusPhieu({
              status: data?.currCode
            })
          }
          payloadAdditional={{exportDate: values?.phieuXuatKhoAdd?.exportDate, content: values?.phieuXuatKhoAdd?.content}}
          handleClick={(data) => setDataReqWorkflow(data)}
        />}
        {isChangeRowData && !isView &&
          <Button
            type="button"
            className="btn btn-fill min-w-90px spaces ms-1"
            onClick={() => {
              handleSubmit();
            }}
          >
            Lưu
          </Button>
        }
      </>
    )
  };
  const handleCloseDialog = () => {
    setDataReqWorkflow({});
  };
  useEffect(() => {
    const isView =
      (values.phieuXuatKhoAdd?.statusId && values.phieuXuatKhoAdd?.statusId === WMS_STATUS.warehouse_approved)
      || statusPhieu.status === WMS_STATUS.warehouse_approved;

    setIsView(isView);
  }, [statusPhieu, values.phieuXuatKhoAdd?.statusId]);

  return (
    <div className="bg-gray">
      {/*<Form className="receive" >*/}
      <div className="spaces width-100 ">
        <ThongTinPhieu
          modelID="phieuXuatKhoAdd"
          listJsonGeneratePhieuXuat={listJsonGeneratePhieuXuat}
          isView={isView}
        />
        <ThongTinXuatThuoc setIsChangeRowData={setIsChangeRowData} isView={isView} statusPhieu={statusPhieu} id={values.phieuXuatKhoAdd?.id} warehouseExportType={warehouseExportType} warehouseId={warehouseId} />

      </div>
      <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-10">
        {renderButton()}
      </div>
      {/*</Form>*/}
      {dataReqWorkflow?.componentName === "ConfirmDialog" &&
          <ConfirmDialog
              show={dataReqWorkflow?.componentName === "ConfirmDialog"}
              title={`Xác nhận ${dataReqWorkflow.reqName}`}
              message={`Bạn chắc chắn muốn ${dataReqWorkflow.reqName} ?`}
              close="Đóng"
              onCloseClick={handleCloseDialog}
              yes="Xác nhận"
              onYesClick={() => {
                dataReqWorkflow.submit && dataReqWorkflow.submit();
                handleCloseDialog();
              }}
          />
      }
    </div>
  );
};
export default FormThemMoi;
